export enum BasiqLocalStorage {
  basiqAccessToken = "basiqAccessToken",
  basiqUserToken = "basiqUserAccessToken",
  basiqUser = "basiqUser",
}

export enum BasiqConsentEnum {
  active = "active",
  revoked = "revoked",
  expired = "expired",
}

export enum BasiqRedirectEnum {
  resync = "resync",
  jobIds = "jobIds",
  state = "state",
  token = "token",
  action = "action",
  connect = "connect",
  institutionId = "institutionId",
  connectionId = "connectionId",
}
